import React from 'react'
import { browserHistory } from 'react-router'
import TextInput from '../TextInput'
import { connect } from 'react-redux'
import 'whatwg-fetch'

class Finalize extends React.Component {

  constructor (props) {
    super(props)

    const self: any = this
    self.finalize = self.finalize.bind(self)
  }

  keySend (e) {
    if (e.keyCode === 13) { this.finalize() }
  }

  finalize () {
    const { setUsername, baseUrl } = this.props
    const username = document.getElementById('username').value
    fetch(`${baseUrl}/finalize`, {
      method: 'POST',
      body: JSON.stringify({ username }),
      credentials: 'include',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          const username = res.msg
          setUsername(username)
          // browserHistory.push('/')
          window.location.href = '/'
        } else {
          alert(res.err || res.message)
        }
      })
  }

  render () {
    const { username, baseUrl } = this.props
    return (
      <div style={{marginTop: '120px'}}>
        <h2>Pick your username</h2>
        <form id='finalize-form'>
          <TextInput type='text' placeholder='username' id='username' placeholder={username} onKeyUp={(e) => this.keySend(e)} /><br />
          <input type='button' value='Finalize' onClick={this.finalize} />
        </form>
      </div>
    )
  }
}

export default Finalize



/** WEBPACK FOOTER **
 ** ./src/components/Users/Finalize.js
 **/